import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { FormProvider, FieldValues, UseFormMethods } from "react-hook-form";

import UnForm from "../../../../Components/Form";
import Select, { MultiValue } from "react-select";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { VendasListarOrigensLeadController } from "../../../../Controllers/Vendas/OrigemLead/OrigemLeadController";
import { ListarEquipesDeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import { IListarCasoRequest } from "../../../../Interfaces/Vendas/Caso/CasoInterface";
import { ListarUsuariosVendasController } from "../../../../Controllers/Vendas/Usuario/UsuarioController";
import { ListarEtapasVendasController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarProdutosInteresseVendasController } from "../../../../Controllers/Vendas/Produtos/ProdutosController";
import { ListarTipoPesoAtendimentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";

interface IFilterOption {
    label: string;
    value: number;
}

interface IFilterGestaoLeads {
    setIdEmpreendimento: Dispatch<SetStateAction<string | undefined>>;
    setIdPesoAtendimento: Dispatch<SetStateAction<string | undefined>>;
    filter: IListarCasoRequest | undefined;
    handleFilter: (formData: any) => void;
    lstCasosLoading: boolean;
    filtroInicial: IListarCasoRequest;
    FormMethods: UseFormMethods<FieldValues>;
}

export default function FilterGestaoLeads(props: IFilterGestaoLeads) {
    const [options, setOptions] = useState<Array<IFilterOption> | undefined>();
    const [optionsPesoAtendimento, setOptionsPesoAtendimento] = useState<
        Array<IFilterOption> | undefined
    >();

    const { reset } = props.FormMethods;

    const idEmpreendimentoRef = useRef<any>();
    const idPesoAtendimentoRef = useRef<any>();

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
        idPesoAtendimentoRef.current?.clearValue();
    };
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarProdutosInteresseVendasController(0),
        []
    );

    const { value: listarPesoAtendimento } = useAsyncEffect(
        () => ListarTipoPesoAtendimentoController(4),
        []
    );

    useEffect(() => {
        setOptions(
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_PRODUTO,
                value: empreendimento.ID_PRODUTO,
            }))
        );
        setOptionsPesoAtendimento(
            listarPesoAtendimento?.map((peso) => ({
                label: peso.DS_TIPO_PESO_ATENDIMENTO,
                value: peso.ID_TIPO_PESO_ATENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos, listarPesoAtendimento]);

    return (
        <FormProvider {...props.FormMethods}>
            <UnForm
                usingContext
                handleSubmit={props.handleFilter}
                className="form-group row"
            >
                <div className="col-12 mt-3">
                    <label>Data Inicial</label>

                    <UnForm.Input
                        className="form-control"
                        type="date"
                        name="DT_INICIO"
                        defaultValue={props.filter?.DT_INICIO}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Data Final</label>
                    <UnForm.Input
                        className="form-control"
                        type="date"
                        name="DT_FIM"
                        defaultValue={props.filter?.DT_FIM}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Tipo de Filtro</label>
                    <UnForm.Select
                        name="FILTRO_DATA"
                        className={`form-control`}
                        defaultValue={props.filter?.FILTRO_DATA ?? 1}
                    >
                        <option value={1}>
                            Data de Abertura da Oportunidade
                        </option>
                        <option value={2}>
                            Data de Fechamento da Oportunidade
                        </option>
                        <option value={3}>Data de Cadastro do Lead</option>
                        <option value={4}>Data da Última Interação</option>
                    </UnForm.Select>
                </div>

                <div className="col-12 mt-3">
                    <label>Status do Caso</label>
                    <UnForm.Select
                        className="form-control"
                        name="DS_SITUACAO"
                        defaultValue={
                            props.filter?.DS_SITUACAO ?? "Em Andamento"
                        }
                    >
                        <option></option>
                        <option>Em Andamento</option>
                        <option>Oportunidade Perdida</option>
                        <option>Oportunidade Ganha</option>
                    </UnForm.Select>
                </div>

                <div className="col-12 mt-3">
                    <div className="row">
                        <div className="col-md-6">
                            <label>Dias Sem interação (de:)</label>
                            <UnForm.Input
                                className="form-control"
                                name="DT_VENCIMENTO_IN"
                                type="number"
                                defaultValue={props.filter?.DT_VENCIMENTO_IN}
                            />
                        </div>
                        <div className="d-flex align-items-end flex-column col-md-6">
                            <label>Dias Sem interação (até:)</label>
                            <UnForm.Input
                                className="form-control"
                                name="DT_VENCIMENTO_FN"
                                type="number"
                                defaultValue={props.filter?.DT_VENCIMENTO_FN}
                            />
                        </div>{" "}
                    </div>
                </div>

                <div className="col-12 mt-3">
                    <label>Lead Vencido</label>
                    <UnForm.Select
                        className="form-control"
                        name="FL_VENCIDO"
                        defaultValue={props.filter?.FL_VENCIDO ?? undefined}
                    >
                        <option value={undefined}></option>
                        <option value={"Sim"}>Sim</option>
                        <option value={"Não"}>Não</option>
                    </UnForm.Select>
                </div>

                <div className="col-12 mt-3">
                    <label>Nome do Lead</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        name="DS_NOME_CONTA"
                        defaultValue={props.filter?.DS_NOME_CONTA}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>CPF</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        maxLength={14}
                        name="NR_CPF"
                        defaultValue={props.filter?.NR_CPF}
                    />
                </div>

                <div className="col-12 mt-3">
                    <label>E-mail</label>
                    <UnForm.Input
                        className="form-control"
                        type="email"
                        name="DS_EMAIL"
                        defaultValue={props.filter?.DS_EMAIL}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Telefone</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        name="NR_TELEFONE"
                        defaultValue={props.filter?.NR_TELEFONE}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Corretor</label>
                    <UnForm.LazySelect
                        controller={ListarUsuariosVendasController}
                        getDS={(equipe) => equipe.DS_NOME}
                        getKeyValue={(equipe) => equipe.ID_USUARIO}
                        className="form-control"
                        name="ID_USUARIO_RESPONSAVEL"
                        defaultValue={props.filter?.ID_USUARIO_RESPONSAVEL}
                    >
                        <option value={0}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="col-12 mt-3">
                    <label>Equipe de Vendas</label>
                    <UnForm.LazySelect
                        controller={ListarEquipesDeVendasController}
                        getDS={(equipe) => equipe.DS_EQUIPE_VENDAS}
                        getKeyValue={(equipe) => equipe.ID_EQUIPE_VENDAS}
                        className="form-control"
                        name="ID_EQUIPE_VENDAS"
                        defaultValue={props.filter?.ID_EQUIPE_VENDAS}
                    >
                        <option value={0}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="col-12 mt-3">
                    <label>Empreendimento</label>
                    <Select
                        name="ID_EMPREENDIMENTO"
                        ref={idEmpreendimentoRef}
                        options={options}
                        isClearable
                        isMulti
                        onChange={(
                            selectedOptions: MultiValue<IFilterOption>
                        ) => {
                            const ids: number[] = selectedOptions.map(
                                (option) => option.value
                            );
                            const idString = ids.join(",");
                            props.setIdEmpreendimento(idString || undefined);
                        }}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        styles={customStyles}
                        placeholder={""}
                        noOptionsMessage={() => "Nenhuma opção"}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Origem do Lead</label>
                    <UnForm.LazySelect
                        className="form-control"
                        name="ID_ORIGEM_LEAD"
                        controller={VendasListarOrigensLeadController}
                        getDS={(origem) => origem.DS_ORIGEM_LEAD}
                        getKeyValue={(origem) => origem.ID_ORIGEM_LEAD}
                        defaultValue={props.filter?.ID_ORIGEM_LEAD}
                    >
                        <option value={0}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="col-12 mt-3">
                    <label>Número da Oportunidade</label>
                    <UnForm.Input
                        className="form-control"
                        type="number"
                        name="NR_OPORTUNIDADE"
                        defaultValue={props.filter?.NR_OPORTUNIDADE}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Etapa</label>
                    <UnForm.LazySelect
                        className="form-control"
                        name="ID_ETAPA_TIPO_CASO"
                        controller={ListarEtapasVendasController}
                        getDS={(origem) =>
                            origem.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                        }
                        getKeyValue={(origem) =>
                            origem.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                        }
                        defaultValue={props.filter?.ID_ETAPA_TIPO_CASO}
                    >
                        <option value={0}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="col-12 mt-3">
                    <label>Peso do Atendimento</label>
                    <Select
                        name="ID_TIPO_PESO_ATENDIMENTO"
                        ref={idPesoAtendimentoRef}
                        options={optionsPesoAtendimento}
                        isClearable
                        isMulti
                        onChange={(
                            selectedOptions: MultiValue<IFilterOption>
                        ) => {
                            const ids: number[] = selectedOptions.map(
                                (option) => option.value
                            );
                            const idString = ids.join(",");
                            props.setIdPesoAtendimento(idString || undefined);
                        }}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        styles={customStyles}
                        placeholder={""}
                        noOptionsMessage={() => "Nenhuma opção"}
                    />
                </div>
                {props.lstCasosLoading ? (
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            className="btn btn-block btn-dark mt-2"
                            style={{ cursor: "default" }}
                        >
                            <Spinner size="sm" />
                        </button>
                    </div>
                ) : (
                    <UnForm.SubmitButton
                        color="success"
                        icon={faFilter}
                        type="submit"
                        className="btn btn-block btn-outline-dark mt-2"
                    >
                        Filtrar
                    </UnForm.SubmitButton>
                )}
                <div className="col-12 d-flex align-items-end justify-content-start">
                    <button
                        type="button"
                        onClick={() => {
                            window.sessionStorage.removeItem(
                                "FILTRO_GESTAO_LEADS_VENDAS"
                            );

                            reset(props.filtroInicial);
                            limparFiltros();
                        }}
                        className="btn btn-block btn-outline-danger mt-2"
                    >
                        <FontAwesomeIcon icon={faTimes} className="mr-2" />
                        Limpar Filtros
                    </button>
                </div>
            </UnForm>
        </FormProvider>
    );
}
